import React, { useEffect, useState } from "react";

export const LineaSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);

  return (
    <select
      className="select-linea"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="C">Consolidado</option>
      <option value="O">Operación</option>
      <option value="R">Revolvente</option>
      <option value="E">Especial</option>
      <option value="M">Mora + 180 dias</option>
      {state.map((item) => (
        <option key={`linea-${item.value}`} value={item.value}>
          {item.linea}
        </option>
      ))}
    </select>
  );
};